/**
 * @generated SignedSource<<7e4e29b35083e8aabe01880a916d4254>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreProductPackageItem_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly activePackages?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly package: {
              readonly id: string | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly upcomingPackages?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly package: {
              readonly id: string | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PackageItemActions_session">;
  readonly " $fragmentType": "StoreProductPackageItem_session";
};
export type StoreProductPackageItem_session$key = {
  readonly " $data"?: StoreProductPackageItem_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductPackageItem_session">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberPackageEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberPackage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "package",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreProductPackageItem_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageItemActions_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "activePackages",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "status",
                      "value": "ACTIVE"
                    }
                  ],
                  "concreteType": "MemberPackageConnection",
                  "kind": "LinkedField",
                  "name": "memberPackages",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": "memberPackages(status:\"ACTIVE\")"
                },
                {
                  "alias": "upcomingPackages",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "status",
                      "value": "UPCOMING"
                    }
                  ],
                  "concreteType": "MemberPackageConnection",
                  "kind": "LinkedField",
                  "name": "memberPackages",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": "memberPackages(status:\"UPCOMING\")"
                }
              ],
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "36e6c2c799e03dadaf8a93581c0999c7";

export default node;
